import * as Yup from "yup";

const uomSchema = {
  validateUOM: () => {
    return Yup.object({
      uom_name: Yup.string()
        .min(2, "UOM Name must be at least 2 characters")
        .max(20, "UOM Name must be at most 20 characters")
        .required("UOM Name is required"),
    });
  },
};

export default uomSchema;
